export enum INVOICE_FILTER_OPTIONS_ENUM {
  INVOICE_NUMBER = 'invoiceNumber',
  INVOICE_SERIE = 'invoiceSerieNumber',
  INVOICE_PART_NUMBER = 'productPartNumber',
  ORDER_NUMBER = 'orderNumber',
  BILLING_PERIOD = 'billingPeriod',
}

export enum INVOICE_STATUS_ENUM {
  INVOICED = 1,
  SHIPPED = 2,
  DELIVERED = 3,
  CANCELED = 4,
  PARTIALLY_PAID = 5,
  PAID = 6,
}

export enum INVOICE_PRODUCT_TYPE_ENUM {
  HARDWARE = 'Hardware',
  SOFTWARE_SERVICE_CLOUD = 'SoftwareAndService',
}

export enum INVOICE_PRODUCT_TYPE_NUM_ENUM {
  HARDWARE = 1,
  SOFTWARE_SERVICE_CLOUD = 2,
}
